"use client";

import CssBaseline from "@mui/material/CssBaseline";

export const UserLayoutClient = (props) => {
  return <>
    <CssBaseline/>
    <main>
      {props.children}
    </main>
  </>;
};